module.exports = __webpack_public_path__ + "img/WheelChair.df6534de.svg";